// extracted by mini-css-extract-plugin
export default {"mockup":"Landing_mockup__ncAuA","logo":"Landing_logo__RfrAR","id-text":"Landing_id-text__+PL9i","form-container":"Landing_form-container__nEwMy"};